import React from 'react'
import { push } from 'react-router-redux'
import auth from '../../../modules/auth'
import api from '../../../modules/api'
import dateformat from 'dateformat'
import moment from 'moment'
import { makeBudgetsArray, isAllowedFileExtension } from '../../../modules/formatting'
import { updateEmailConfirmationSettings } from '../../../routes/emailConfirmation/modules/emailConfirmation'
import _ from 'lodash'
import PromisePool from 'es6-promise-pool'
import axios from 'axios'

// Constant
import {
  UPDATE_SIGNUP_DATA,
  FETCH_SIGNUP_DATA_REQUEST,
  FETCH_SIGNUP_ADDRESSES_REQUEST,
  SIGNUP_REQUEST,
  SIGNUP_SAVE_PASSWORD_REQUEST,
  SEND_SMS_REQUEST,
  RECEIVE_SMS_AUTH_CODE_REQUEST,
  FETCH_REQUEST_INFO_REQUEST,
  UPDATE_REQUEST_INFO_REQUEST,
  SEARCH_HOSPITAL_REQUEST,
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_S3_REQUEST,
  UPLOAD_DIRECTORY_REQUEST,
  UPDATE_DIRECTORY_UPLOAD_PROGRESS,
  FETCH_CONSULTATION_OPTIONS_REQUEST,
  DELETE_FILE_REQUEST,
  DELETE_DIRECTORY_UPLOAD_REQUEST,
  FETCH_PAYJP_INFO_REQUEST,
  FETCH_ANNOTATION_PRICE_REQUEST,
  FETCH_DATA_FILE_REQUEST,
  UPDATE_FILE_TARGET_ID_REQUEST,
  UPDATE_QUESTIONS,
  TOGGLE_ANNOTATION_IMAGE_MODAL } from '../../../modules/actions'

// Action
export const initialState = {
  findmeId: '000000',
  step: 1,
  progress: [
    {
      id: 1,
      name: '会員登録'
    },
    {
      id: 2,
      name: 'パスワード'
    },
    {
      id: 3,
      name: '電話番号確認'
    },
    {
      id: 4,
      name: '相談入力'
    },
    {
      id: 5,
      name: 'お支払い'
    }
  ],

// ------------------------------------
// TODO: FM-265 リニューアル後削除
  genders: [
    {
      id: 'male',
      name: '男性'
    },
    {
      id: 'female',
      name: '女性'
    }
  ],
  sourceOptions: [
    {
      id: 'introduce',
      name: '知人の紹介'
    },
    {
      id: 'introduce-doctor',
      name: '医師の紹介'
    },
    {
      id: 'introduce-medical',
      name: '医療従事者の紹介'
    },
    {
      id: 'facebook',
      name: 'Facebook'
    },
    {
      id: 'search',
      name: 'ネット検索'
    },
    {
      id: 'advertisement',
      name: '広告など'
    },
    {
      id: 'pamphlet',
      name: 'パンフレット'
    },
    {
      id: 'other',
      name: 'その他'
    }
  ],
  patientTypes: [
    {
      id: 'myself',
      name: 'ご本人'
    },
    {
      id: 'relative',
      name: '患者さん本人とご相談者が異なる'
    }
  ],
  numberHospitals: [
    {
      id: 1,
      name: '1 施設'
    },
    {
      id: 2,
      name: '2 施設'
    },
    {
      id: 3,
      name: '3 施設'
    },
    {
      id: 4,
      name: '4 施設'
    },
    {
      id: 5,
      name: '5 施設以上'
    },
  ],
  customer_addresses: [],
  customer_firstName: '',
  customer_lastName: '',
  customer_firstNameReading: '',
  customer_lastNameReading: '',
  customer_restAddress: '',
  customer_gender: '',
  customer_age: '',
  customer_sourceOption: '',
  customer_sourceCode: '',
  customer_prefectureId: '',
  customer_addressId: '',
  firstName: '',
  lastName: '',
  firstNameReading: '',
  lastNameReading: '',
  gender: 'male', // 'male', 'female'
  patientFirstName: '',
  patientLastName: '',
  patientEmail: '',
  restAddress: '',
  cancerSteps: [
    {
      id: 'period1',
      name: 'I期'
    },
    {
      id: 'period2',
      name: 'II期'
    },
    {
      id: 'period3',
      name: 'III期'
    },
    {
      id: 'period4',
      name: 'IV期'
    },
  ],
  cancerTypes: [
    {
      id: 'new',
      name: '初発'
    },
    {
      id: 'old',
      name: '再発'
    },
    {
      id: 'metastasis',
      name: '再発・転移'
    },
    {
      id: 'not_metastasis',
      name: '再発・転移ではない'
    }
  ],
  diseases: [
    {
      id: 'breast_cancer',
      name: '乳がん',
      icd10: 'C509',
    }, {
      id: 'uterine_cancer',
      name: '子宮がん',
      icd10: 'C539',
    }, {
      id: 'ovarian_cancer',
      name: '卵巣がん',
      icd10: 'C509',
    }, {
      id: 'prostate_cancer',
      name: '前立腺がん',
      icd10: 'C61',
    }, {
      id: 'lung_cancer',
      name: '肺がん',
      icd10: 'C349',
    }, {
      id: 'colon_cancer',
      name: '大腸がん',
      icd10: 'C189',
    }, {
      id: 'stomach_cancer',
      name: '胃がん',
      icd10: 'C169',
    }, {
      id: 'liver_cancer',
      name: '肝臓がん',
      icd10: 'C220',
    }, {
      id: 'cervical_cancer',
      name: '子宮頸がん',
      icd10: 'C539',
    }, {
      id: 'uterine_body_cancer',
      name: '子宮体がん',
      icd10: 'C549',
    }, {
      id: 'other',
      name: 'その他',
    }
  ],
  icd10Name: '',
  icd10s: [], // icd10 suggestions array
  numberHospital: '',
  previousTreatments: '',
  budget: '',
  currentSituation: '',
  budgets: [
    {
      id: '',
      name: '入力しない'
    },
    ...makeBudgetsArray(20000, 50000, 5000)
  ],
  age: '',
  patientRestAddress: '',
  hasDocument: true,
  postOfficeDocument: false,
// end FM-265
// ------------------------------------
  requestId: '',
  isSentRequest: false,
  isFetchedRequestData: false,
  terms: '',
  prefectures: [],
  addresses: [],
  email: '',
  password: '',
  sourceCode: '',
  patientType: 'myself', // "myself" / "relative"
  documentState: '',
  otherDocumentState: '',
  consultationDetail: '',
  answer1Description: '',
  answer2Description: '',
  answer3Description: '',
  answer4Description: '',
  offerArea: [],
  currentQuestion: 0,
  diseaseName: '',
  diseaseNameOther: '',
  otherDiseaseNames: [],
  otherDiseaseNamesOther: '',
  birthYear: 1970,
  documentByPost: '',
  patientConsent: false,
  prefectureId: '',
  addressId: '',
  allowTerms: false,
  consultationOption: [],
  desiredProposals: 1,
  expirationDate: '',
  expirationDateMin: '',
  expirationDateMax: '',
  expirationDateComment: '',
  subjectConsultation: '',
  icd10: '',
  cancerStep: '',
  cancerType: '',
  cancerStepOther: '',
  contentConsultation: '',
  consultationOptions: [],
  returnAddress: {
    name: '',
    postcode1: '',
    postcode2: '',
    address1: '',
    address2: '',
    address3: '',
    street: '',
    phoneNumber: ''
  },
  files: [],
  directoryUploads: {},
  isSavedByCustomer: null,
  payjpToken: '',
  annotationPrice: {},
  payjpInfo: null,
  prices: {},
  hospitals: [],
  hospitalId: '',
  hospitalName: '',
  wantTransfer: '',
  speciality: '',
  doctorName: '',
  autoSaveNotification: '',
  status: '',
  editable: false,
  fileData: {},
  openAnnotationImageModal: false,
  // campaign settings
  waitingForCampaignConfirmation: false,
  errors: {},
  // Support Chatroom ID
  chatroomId: -1,
  currentlyUpdating: false, // whether there is an update in progress or not
  questionTypes: {
    RADIO: 'RADIO',
    CHECKBOX: 'CHECKBOX',
    TEXTAREA: 'TEXTAREA',
    OFFER_AREA: 'OFFER_AREA',
    BIRTH_YEAR: 'BIRTH_YEAR',
    HOSPITAL_NAME: 'HOSPITAL_NAME',
    SCHEDULE: 'SCHEDULE',
    UPLOADER: 'UPLOADER',
    ADDRESS: 'ADDRESS',
    MESSAGE: 'MESSAGE',
    ATTENTION: 'ATTENTION',
    COMMISSION: 'COMMISSION',
    TO_PAYMENT: 'TO_PAYMENT',
    CONSULTATION: 'CONSULTATION'
  },
  choices: [],
  questions: [],
  campaign: '',
  freecall: '0120-227-810',
  supportExtra: '',
  phoneNumber: '',
  authenticationCode: '',
  requiredQuestionAnsweredAt: '',
  optionalQuestionAnsweredAt: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SIGNUP_DATA:
      return {
        ...state,
        ...action.payload
      }
    case UPDATE_QUESTIONS:
      let choices = makeChoices(state)
      let questions = makeQuestions(state, choices)
      if(state.campaign === 'FWD') {
        state.freecall = '0120-308-297'
      }
      if(state.campaign === 'AFLAC') {
        state.freecall = '0120-668-608'
      }
      return {
        ...state,
        ...action.payload,
        choices,
        questions
      }
    case TOGGLE_ANNOTATION_IMAGE_MODAL:
      return {
        ...state,
        src: action.src,
        openAnnotationImageModal: !state.openAnnotationImageModal
      }
    case UPDATE_REQUEST_INFO_REQUEST:
      return {
        ...state,
        currentlyUpdating: true
      }
    case UPDATE_DIRECTORY_UPLOAD_PROGRESS:
      let directoryUploads = Object.assign({}, state.directoryUploads)
      let uploadDetails = Object.assign({}, action)
      delete uploadDetails.type

      directoryUploads[action.id] = {
        ...(state.directoryUploads[action.id] || {}),
        ...uploadDetails
      }
      return {
        ...state,
        directoryUploads,
      }
    default:
      return state
  }
}

export const updateSignUpData = (payload) => ({
  type: UPDATE_SIGNUP_DATA,
  payload
})

export const fetchSignupDataRequest = () => ({
  type: FETCH_SIGNUP_DATA_REQUEST,
})

export const fetchSignupAddressesRequest = (prefectures, target, addressIdTarget) => ({
  type: FETCH_SIGNUP_ADDRESSES_REQUEST,
  prefectures,
  target,
  addressIdTarget
})

export const signupRequest = (payload) => ({
  type: SIGNUP_REQUEST,
  info: payload.info,
  successCallback: payload.successCallback,
  failCallback: payload.failCallback
})

export const signupSavePasswordRequest = ({info, successCallback, failCallback}) => ({
  type: SIGNUP_SAVE_PASSWORD_REQUEST,
  info,
  successCallback,
  failCallback
})
export const sendSMSRequest = ({info, successCallback, failCallback}) => ({
  type: SEND_SMS_REQUEST,
  info,
  successCallback,
  failCallback
})
export const receiveSMSAuthCodeRequest = ({info, successCallback, failCallback}) => ({
  type: RECEIVE_SMS_AUTH_CODE_REQUEST,
  info,
  successCallback,
  failCallback
})
export const updateRequestInfoRequest = (payload) => ({
  type: UPDATE_REQUEST_INFO_REQUEST,
  id: payload.id,
  data: payload.data,
  successCallback: payload.successCallback,
  delay: payload.delay,
})

export const searchHospitalRequest = (keyword) => ({
  type: SEARCH_HOSPITAL_REQUEST,
  keyword
})

export const uploadFileRequest = (payload) => ({
  type: UPLOAD_FILE_REQUEST,
  id: payload.id,
  data: payload.data,
  successCallback: payload.successCallback
})

export const uploadDirectoryRequest = ({ requestId, fileCount, totalFileSize, successCallback }) => ({
  type: UPLOAD_DIRECTORY_REQUEST,
  requestId,
  fileCount,
  totalFileSize,
  successCallback,
})

export const updateDirectoryUploadProgress = ({ directoryUploadId, progressPercent, finalized = false, ...rest }) => ({
  type: UPDATE_DIRECTORY_UPLOAD_PROGRESS,
  id: directoryUploadId,
  progressPercent,
  finalized,
  ...rest
})

export const updateQuestions = (payload) => ({
  type: UPDATE_QUESTIONS,
  payload
})

export const uploadFileToS3 = ({url, fields, onUploadProgress, successCallback}) => ({
  type: UPLOAD_FILE_S3_REQUEST,
  url, fields, onUploadProgress, successCallback
})

export const fetchRequestInfoRequest = () => ({
  type: FETCH_REQUEST_INFO_REQUEST
})

export const fetchConsultationOptionsRequest = () => ({
  type: FETCH_CONSULTATION_OPTIONS_REQUEST
})

export const deleteFileRequest = (payload) => ({
  type: DELETE_FILE_REQUEST,
  fileId: payload.fileId,
  successCallback: payload.successCallback
})

export const deleteDirectoryUploadRequest = (payload) => ({
  type: DELETE_DIRECTORY_UPLOAD_REQUEST,
  requestId: payload.requestId,
  directoryUploadId: payload.directoryUploadId,
  successCallback: payload.successCallback
})

export const fetchPayjpInfoRequest = (token) => ({
  type: FETCH_PAYJP_INFO_REQUEST,
  token
})

export const fetchAnnotationPriceRequest = (requestId) => ({
  type: FETCH_ANNOTATION_PRICE_REQUEST,
  requestId
})

// Thunks
export const signup = () => {
  return (dispatch, getState) => {
    let state = getState()
    let signup = state.signup


    // validate form
    if (!signup.allowTerms) {
      return
    }

    // reset errors
    dispatch(updateSignUpSettings({
      isSubmitting: true,
      errors: {}
    }))

    let info = {
      customer_info: {
        email: signup.email,
      },
      request_info: {
        campaign_from: signup.campaignFrom
      },
    }

    // leave the rest thing for redux-saga
    dispatch(signupRequest({
      info: info,
      successCallback: () => dispatch(signupResponse()),
      failCallback: (response) => dispatch(signupFailResponse(response))
    }))
  }
}

export const signupResponse = () => {
  return (dispatch, getState) => {
    const state = getState()

    // ログイン処理は行わない（メール認証後に /account-confirmation で行われる）
    // move to email-confirmation route to notify customer check email
    // or resend email if not available
    dispatch(updateEmailConfirmationSettings({
      email: state.signup.email
    }))
    dispatch(push('/email-confirmation'))
  }
}

export const signupFailResponse = (response) => {
  return (dispatch) => {
    let errors = {}

    if (response.error.code === 'invalid_term') {
      errors = {
        ...errors,
        email: '入力されたコードの有効期限が切れています'
      }
    } else if (response.error.code === 'already_used') {
      errors = {
        ...errors,
        email: '入力されたコードは既に使用されています'
      }
    }

    dispatch(updateSignUpSettings({
      errors: errors,
      isSubmitting: false,
    }))
  }
}

export const signupSavePassword = (nextSignUpStep = 3) => {
  return (dispatch, getState) => {
    let state = getState()
    let {password, phoneNumber} = state.signup

    let info = {
      customer_info: {
        password,
        phone_number: phoneNumber
      }
    }

    dispatch(signupSavePasswordRequest({
      info: info,
      successCallback: (data) => {
        // Update local/session storage with new value of
        // initial_password_set
        auth.updateCustomerInfo(data.customer)
        // return dispatch(changeSignUpStep(nextSignUpStep))
        dispatch(sendSMSRequest({
          info: info,
          successCallback: (data) => {
            // return dispatch(changeSignUpStep(nextSignUpStep))
            return dispatch(changeSignUpStep(nextSignUpStep))
          },
          failCallback: (response) => {
            return dispatch(signupSavePasswordFailResponse(response))
          }
        }))
      },
      failCallback: (response) => {
        return dispatch(signupSavePasswordFailResponse(response))
      }
    }))
  }
}

export const signupSavePasswordFailResponse = (response) => {
  return (dispatch) => {
    let details = response.error.details
    let errors = {}

    for (let i = 0; i < details.length; i++) {
      let error = details[i]
      switch (error.field) {
        case 'password':
          switch (error.code) {
            case 'too_short':
              errors = {
                ...errors,
                password: 'パスワードは8文字以上で設定してください'
              }
              break
            case 'invalid':
              errors = {
                ...errors,
                password: "パスワードは半角英大文字、半角英小文字、半角数字、記号（!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~）の4種類をすべて使用して設定してください"
              }
              break
            default:
              break
          } // end inner switch
          break

        default:
          break
      } // end outer switch
    } // end for

    dispatch(updateSignUpSettings({
      errors: errors
    }))
  }
}

export const signupResendSMS = () => {
  return (dispatch, getState) => {
    dispatch(sendSMSRequest({
      info: {},
      successCallback: (data) => {},
      failCallback: (response) => {}
    }))
  }
}

export const signupReceiveAuthCode = (authenticationCode, nextSignUpStep = 4) => {
  return (dispatch, getState) => {
    let info = {
      customer_info: {
        authentication_code: authenticationCode
      }
    }

    dispatch(receiveSMSAuthCodeRequest({
      info: info,
      successCallback: (data) => {
        return dispatch(changeSignUpStep(nextSignUpStep))
      },
      failCallback: (response) => {
        return dispatch(signupReceiveAuthCodeFailResponse(response))
      }
    }))
  }
}

export const signupReceiveAuthCodeFailResponse = (response) => {
  return (dispatch) => {
    const errors = {
      authenticationCode: '認証コードの認証に失敗しました。'
    }

    dispatch(updateSignUpSettings({
      errors: errors
    }))
  }
}

export const sortByChoices = (data, choices) => {
  let param = []
  if(choices) {
    choices.forEach(choice => {
      if(data.indexOf(choice.id) !== -1) {
        param.push(choice.id)
      }
    })
  }
  return param
}

export const makeRequestPostData = (data) => {
  // other_disease_names等のArrayをjsonの都合上Stringにしている。
  let otherDiseaseNames = sortByChoices(data.otherDiseaseNames, data.choices.otherDiseaseNamesList)
  let consultationOption = sortByChoices(data.consultationOption, data.choices.consultationOptions)
  let reachedStep = data.reachedStep < data.step ?
    data.step : data.reachedStep
  let disease = data.diseases.filter(
    disease => disease.id === data.diseaseName
  )[0]
  let icd10Code = disease ? disease.icd10 : ''

  return {
    customer_info: {
      source_code: data.customer_sourceCode,
      phone_number: data.phoneNumber
    },
    request_info: {
      patient_type: data.patientType,
      prefecture_id: data.prefectureId,
      expiration_date: data.expirationDate,
      info: {
        request_version: 2,
        patient_consent: data.patientConsent, // 家族相談時の同意チェック
        current_question: data.currentQuestion,
        current_step: data.step,
        is_sent_request: data.isSentRequest,
        reached_step: reachedStep,
        disease_name: data.diseaseName, // 病名
        disease_name_other: data.diseaseNameOther, // 病名（その他）
        other_disease_names: _.toString(otherDiseaseNames), // 他の疾患
        other_disease_names_other: data.otherDiseaseNamesOther, // 他の疾患（その他）
        birth_year: data.birthYear || initialState.birthYear, // 誕生年
        cancer_step: data.cancerStep,
        cancer_step_other: data.cancerStepOther,
        cancer_type: data.cancerType, // がん初発 or 再発
        consultation_option: _.toString(consultationOption), // ご相談内容
        consultation_option_other: data.consultationOptionOther, // ご相談内容(その他)
        answer1_description: data.answer1Description,
        answer2_description: data.answer2Description,
        answer3_description: data.answer3Description,
        answer4_description: data.answer4Description,
        want_transfer: data.wantTransfer, // 転院希望
        offer_area: _.toString(data.offerArea), // オファー地域 (県id array)
        hospital_id: data.hospitalId, // 病院ID
        hospital_name: data.hospitalName, // 病院名
        content: data.contentConsultation, // 具体的な相談内容
        expiration_date_comment: data.expirationDateComment, // 期限の補足
        document_state: data.documentState, // 紹介状の状態
        other_document_state: data.otherDocumentState, // 他の書類
        submission_method: data.submissionMethod, // 書類提出方法
        return_address_address1: data.returnAddress.address1,
        return_address_address2: data.returnAddress.address2,
        return_address_address3: data.returnAddress.address3,
        return_address_street: data.returnAddress.street,
        return_address_name: data.returnAddress.name,
        return_address_phoneNumber: data.returnAddress.phoneNumber,
        return_address_postcode1: data.returnAddress.postcode1,
        return_address_postcode2: data.returnAddress.postcode2,
        icd_10_code: icd10Code,
        support_extra: data.supportExtra,
        required_question_answered_at: data.requiredQuestionAnsweredAt,
        optional_question_answerd_at: data.optionalQuestionAnsweredAt,
        phone_number: data.phoneNumber
      },
    }
  }
}

const makeChoices = (state = initialState) => {
  let choices = {
    diseaseNames: [
      {
        id: 'breast_cancer',
        name: '乳がん',
      }, {
        id: 'uterine_cancer',
        name: '子宮がん',
      }, {
        id: 'ovarian_cancer',
        name: '卵巣がん',
      }, {
        id: 'prostate_cancer',
        name: '前立腺がん',
      }, {
        id: 'lung_cancer',
        name: '肺がん',
      }, {
        id: 'colon_cancer',
        name: '大腸がん',
      }, {
        id: 'stomach_cancer',
        name: '胃がん',
      }, {
        id: 'liver_cancer',
        name: '肝臓がん',
      }, {
        id: 'other',
        name: 'その他(記入)',
        isFreeDescription: true,
      }
    ],
    otherDiseaseNamesList: [
      {
        id: 'heart',
        name: '心疾患に対して内服治療中',
      }, {
        id: 'dialysis',
        name: '人工透析を行っている',
      }, {
        id: 'insulin',
        name: '糖尿病薬の内服あるいはインスリン治療中',
      }, {
        id: 'respiratory',
        name: '呼吸器疾患に対して内服治療中',
      }, {
        id: 'other',
        name: 'その他(記入)',
        isFreeDescription: true,
      }
    ],
    patientTypes: [
      {
        id: 'myself',
        name: '患者本人',
      }, {
        id: 'relative',
        name: 'ご家族等',
        requiresConsent: true,
      }
    ],
    documentStates: [
      {
        id: 'have',
        name: 'はい、持っています',
      }, {
        id: 'pending',
        name: '準備中・これから準備する',
      }, {
        id: 'none',
        name: 'いいえ、持っていません',
      }
    ],
    otherDocumentStates: [
      {
        id: 'have',
        name: 'はい、持っています',
      }, {
        id: 'none',
        name: 'いいえ',
      }
    ],
    cancerSteps: [
      {
        id: 'period0',
        name: '0期',
      },
      {
        id: 'period1',
        name: 'I期',
      },
      {
        id: 'period2',
        name: 'II期',
      },
      {
        id: 'period3',
        name: 'III期',
      },
      {
        id: 'period4',
        name: 'IV期',
      },
      {
        id: 'unknown',
        name: 'わからない',
      },
      {
        id: 'other',
        name: '詳細を入力する（IIA期、IIB期、IIA1期、IIA2期 などを記入）',
        isFreeDescription: true,
      }
    ],
    cancerTypes: [
      {
        id: 'new',
        name: '初発'
      },
      {
        id: 'old',
        name: '再発（難治性含む）'
      }
    ],
    cancerTypesFWD001: [
      {
        id: 'metastasis',
        name: '再発・転移である'
      },
      {
        id: 'not_metastasis',
        name: '再発・転移ではない'
      }
    ],
    consultationDetails: [
      {
        id: 'answer1',
        name: '主治医から説明・提案されている治療方法で良いのかどうか、他の医師の考えや意見が聞きたい',
        details: [{
          id: 'answer1Description',
          type: 'textarea',
          required: false,
          visible: true,
          infomation: 'いつ、どのような検査をもって診断され、現在に至りますか？ これまでに行った治療法等もございましたら、ご入力ください。また、主治医からは今後どのような治療を提示（説明）されていますか？',
          placeholder: '入力してください',
        }]
      }, {
        id: 'answer2',
        name: '主治医から説明・提案されている治療方法以外に、選択可能な治療方法があれば知りたい',
        details: [{
          id: 'answer2Description',
          type: 'textarea',
          required: false,
          visible: true,
          infomation: 'どのような治療法を探されていますか？また、その理由を教えてください。',
          placeholder: '入力してください',
        }]
      }, {
        id: 'answer3',
        name: '受けてみたいと思っている治療方法の可否について、教えてほしい',
        details: [{
          id: 'answer3Description',
          type: 'textarea',
          required: false,
          visible: true,
          infomation: 'どのような治療を希望されていますか？また、その理由を教えてください。',
          placeholder: '入力してください',
        }]
      }, {
        id: 'answer4',
        name: '病気や治療方法についてわからないところを説明してほしい',
        details: [{
          id: 'answer4Description',
          type: 'textarea',
          required: false,
          visible: true,
          infomation: 'どのようなことがわからず、説明をしてほしいと思っているのか教えてください。',
          placeholder: '入力してください',
        }]
      }, {
        id: 'other',
        name: 'その他(記入)',
        isFreeDescription: true,
      }
    ],
    consultationOptions: [
      {
        id: 'answer1',
        name: '現在の治療方針が妥当なのかどうか他の先生の意見を聞きたい',
      }, {
        id: 'answer2',
        name: '現在の治療方針以外の選択肢を知りたい',
      }, {
        id: 'answer3',
        name: '自分が希望する治療方針が可能なのかを知りたい',
      }, {
        id: 'answer4',
        name: '病気や治療方法についてわからないところを説明してほしい',
      }, {
        id: 'other',
        name: 'その他(記入)',
        isFreeDescription: true,
      }
    ],
    submissionMethods: [
      {
        id: 'upload',
        name: 'ファイルをアップロード',
      }, {
        id: 'post',
        name: `郵送する（有料： ${state.prices.post_mail_price}円 税抜）`,
      }
    ],
    yesOrNo: [
      {
        id: 'yes',
        name: 'はい',
      },
      {
        id: 'no',
        name: 'いいえ',
      },
    ],
    diseaseNamesFWD001: [
      {
        id: 'breast_cancer',
        name: '乳がん',
      }, {
        id: 'cervical_cancer',
        name: '子宮頸がん',
      }, {
        id: 'uterine_body_cancer',
        name: '子宮体がん',
      }, {
        id: 'ovarian_cancer',
        name: '卵巣がん',
      }, {
        id: 'other',
        name: 'その他(記入)',
        isFreeDescription: true,
      }
    ],
    submissionMethodsNotPay: [
      {
        id: 'upload',
        name: 'ファイルをアップロード',
      }, {
        id: 'post',
        name: `郵送する`,
      }
    ],
  }
  return choices
}

const questionList = (state, choices) => {
  const questions = [
    // -------------------------------------------
    // 質問リスト
    // id: String.isRequired, 答えの格納key
    // name: String.isRequired, 質問名。質問一覧の作成(makeQuestions)で指定する
    // title: Object.isRequired, 質問タイトル
    // type: String.isRequired, 質問テンプレートタイプ
    // choices: Array.isRequired, 質問の選択肢、無い場合はnullにする
    // isVisible: Bool.isRequired, 質問の表示される条件を記述
    // isRequired: Bool.isRequired, 入力必須項目 progressの分母に使用
    // isCounted: Bool, 進捗数に含めるか
    // message: Object, メッセージが表示されるタイプの場合の内容
    // otherId: String, 任意入力・その他の格納Key
    // placeholder: String, TEXTAREA、RADIO、CHECKBOXに入力欄がある場合
    // canSkip: Bool, 未入力で次の質問に移動可能か
    // maxLength: Number, text、textareaの入力最大値 初期値(text:30,textarea:null)
    // row: Number, textareaの行数、この値が指定された場合はresizeさせない
    // consentId: String, 選択肢に requiresConsent が付いた場合の同意チェック格納Key
    // consentText: String, 同意チェックのラベル文言
    // -------------------------------------------
    {
      id: 'patientType',
      name: 'patientType',
      title: 'ご相談者は患者さんご本人ですか？',
      type: state.questionTypes.RADIO,
      choices: choices.patientTypes,
      isVisible: true,
      isRequired: true,
      isCounted: true,
      consentId: 'patientConsent',
      consentMessage: '患者さん本人にご確認のうえ、チェックをお願いします',
      consentText: '相談者がセカンドオピニオンを依頼し、その結果を取得することに、患者さん本人が同意している',
    }, {
      id: 'diseaseName',
      name: 'diseaseName',
      title: 'ご相談したい病名を入力ください',
      type: state.questionTypes.RADIO,
      choices: choices.diseaseNames,
      otherId: 'diseaseNameOther',
      isVisible: true,
      isRequired: true,
      isCounted: true,
      placeholder: '病名を入力ください（最大20文字）',
      maxLength: 20,
    }, {
      id: 'diseaseName',
      name: 'diseaseNameFWD001',
      title: '病名をご入力ください',
      type: state.questionTypes.RADIO,
      choices: choices.diseaseNamesFWD001,
      otherId: 'diseaseNameOther',
      isVisible: true,
      isRequired: true,
      isCounted: true,
      placeholder: '病名を入力ください（最大20文字）',
      annotation: '上記４種のがんが本サービスの対象ですが、ご自身の診断名が上記と異なる場合はその他へご入力ください。',
      maxLength: 20,
    }, {
      id: 'birthYear',
      name: 'birthYear',
      title: '生まれた年を選択してください',
      type: state.questionTypes.BIRTH_YEAR,
      choices: null,
      isVisible: true,
      isRequired: true,
      isCounted: true,
    }, {
      id: 'consultationOption',
      name: 'consultationDetails',
      title: 'ご相談内容をお選びください',
      type: state.questionTypes.CONSULTATION,
      choices: choices.consultationDetails,
      otherId: 'consultationOptionOther',
      isVisible: true,
      isRequired: true,
      isCounted: true,
      maxLength: 30,
    }, {
      id: 'consultationOption',
      name: 'consultationOption',
      title: 'ご相談内容をお選びください',
      type: state.questionTypes.CHECKBOX,
      choices: choices.consultationOptions,
      otherId: 'consultationOptionOther',
      isVisible: true,
      isRequired: true,
      isCounted: true,
      annotation: '具体的なご相談内容は、あとでご記入いただけます',
      maxLength: 30,
    }, {
      id: 'consultationOption',
      name: 'consultationOptionFWD001',
      title: 'ご相談内容をお選びください',
      type: state.questionTypes.CHECKBOX,
      choices: choices.consultationOptions,
      otherId: 'consultationOptionOther',
      isVisible: true,
      isRequired: true,
      isCounted: true,
      maxLength: 30,
    }, {
      id: 'cancerType',
      name: 'cancerType',
      title: 'がんは再発（難治性含む）ですか',
      type: state.questionTypes.RADIO,
      choices: choices.cancerTypes,
      isVisible: true,
      isRequired: true,
      isCounted: true,
    }, {
      id: 'cancerType',
      name: 'cancerTypeFWD001',
      title: 'がんは再発・転移ですか？',
      type: state.questionTypes.RADIO,
      choices: choices.cancerTypesFWD001,
      isVisible: true,
      isRequired: true,
      isCounted: true,
      annotation: '最初にできたがんの場合は、「再発・転移ではない」をお選びください。',
    }, {
      id: 'cancerStep',
      name: 'cancerStep',
      title: 'がんの病期（ステージ）をご選択ください',
      type: state.questionTypes.RADIO,
      choices: choices.cancerSteps,
      isVisible: true,
      isRequired: true,
      isCounted: true,
      otherId: 'cancerStepOther',
      placeholder: 'IIA期、IIB期、IIA1期、IIA2期 など'
    }, {
      id: 'otherDiseaseNames',
      name: 'otherDiseaseNames',
      title: '現在治療中のほかのご病気があれば選択してください',
      type: state.questionTypes.CHECKBOX,
      choices: choices.otherDiseaseNamesList,
      otherId: 'otherDiseaseNamesOther',
      isVisible: true,
      isCounted: true,
      canSkip: true,
    }, {
      id: 'hospitalName',
      name: 'hospitalName',
      title: '通院中の病院名をご入力ください',
      description: <div className="question-description__notice">
        通院中の病院の医師に公開を避けるためです。
      </div>,
      type: state.questionTypes.HOSPITAL_NAME,
      choices: null,
      isVisible: true,
      isRequired: true,
      isCounted: true,
      annotation: '通院中の病院名はセカンドオピニオンを提供する医師にとっても有用な情報です。',
    }, {
      id: 'wantTransfer',
      name: 'wantTransfer',
      title: 'セカンドオピニオンの内容によっては、転院を希望する可能性がありますか？',
      type: state.questionTypes.RADIO,
      choices: choices.yesOrNo,
      isVisible: true,
      isRequired: true,
      isCounted: true,
    }, {
      id: 'offerArea',
      name: 'offerArea',
      title: '転院を希望される場合、セカンドオピニオンを依頼したい医師の地域にご希望があれば選択ください',
      type: state.questionTypes.OFFER_AREA,
      choices: null,
      isVisible: state.wantTransfer === 'yes',
      isRequired: false,
      annotation: 'できる限りご希望に添えるよう対応いたしますが、必ずしも該当地域の医師からのご回答をお約束するものではございません',
    }, {
      id: 'expirationDate',
      name: 'expirationDate',
      title: '医師の立候補を募集する期限をご入力ください。（最短で本日から7日）',
      type: state.questionTypes.SCHEDULE,
      choices: null,
      isVisible: true,
      isRequired: true,
      isCounted: true,
      annotation:  `指定期限まで${state.campaign === "FWD" ? 'Findme F' : "Findme"}が医師を募集し、セカンドオピニオンの立候補をお届けします。`,
    }, {
      id: 'expirationDate',
      name: 'expirationDateFWD001',
      title: '医師からセカンドオピニオンの申出を募集する期限をご入力ください。（最短で本日から7日）',
      type: state.questionTypes.SCHEDULE,
      choices: null,
      isVisible: true,
      isRequired: true,
      isCounted: true,
      annotation: <span style={{border: 'solid 2px #FED141', padding: '10px 12px', display: 'block', textAlign: 'left'}}>医師からセカンドオピニオンの申出が届いた後、セカンドオピニオンのレポートをご依頼いただき、その後10日以内に医師がレポートを作成してお送りします。<br/>ここでご入力いただく期限までにセカンドオピニオンのレポート提出をお約束するものではございませんが、お急ぎの事情がありましたら、次ページにてご記載ください。</span>,
    }, {
      id: 'expirationDateComment',
      name: 'expirationDateComment',
      title: '今後の受診や治療予定等に応じてセカンドオピニオン取得をお急ぎの事情があれば具体的にご記入ください',
      type: state.questionTypes.TEXTAREA,
      choices: null,
      isVisible: true,
      isRequired: false,
      isCounted: true,
      placeholder: `${moment().add(7,'days').format('YYYY年MM月DD日')}から抗がん剤治療を始める予定であるが、その前にセカンドオピニオンレターを読みたい。`,
      row: 2,
      annotation: 'できる限りご希望に添えるよう対応いたしますが、必ずしも期間内のセカンドオピニオン提供をお約束するものではございません。',
    }, {
      id: 'toPayment',
      name: 'toPayment',
      title: '必須項目を入力いただきありがとうございました',
      type: state.questionTypes.TO_PAYMENT,
      message: <div>そのまま登録の完了に進めますが、より個別的なセカンドオピニオンを得るために、お手元にある資料のアップロードをお勧めいたします。</div>,
      choices: null,
      isVisible: true,
      isRequired: false,
    }, {
      id: 'toNextStep',
      name: 'toNextStep',
      title: 'ご入力いただき\nありがとうございました',
      type: state.questionTypes.TO_PAYMENT,
      message: <div>そのままご利用を開始できますが、より正確なセカンドオピニオンを得るため、詳しい相談や資料のアップロードをお勧めします</div>,
      choices: null,
      isVisible: true,
      isRequired: false,
    }, {
      id: 'documentState',
      name: 'documentState',
      title: '紹介状はお持ちですか？\n紹介状がなくてもご利用いただけます',
      type: state.questionTypes.RADIO,
      choices: choices.documentStates,
      annotation: '紹介状とは？',
      modalContent: 'aboutDoc',
      isVisible: true,
      isRequired: false,
      canSkip: true,
    }, {
      id: 'attention',
      name: 'attention',
      title: state.documentState === 'pending' ?
        '紹介状準備中の方' :
        '紹介状なしが選択されました',
      type: state.questionTypes.MESSAGE,
      messageKey: state.documentState,
      isVisible: state.documentState === 'none' || state.documentState === 'pending',
      isRequired: false,
      choices: null,
    }, {
      id: 'otherDocumentState',
      name: 'otherDocumentState',
      title: '他の書類（病理検査データなど）はお持ちですか？',
      type: state.questionTypes.RADIO,
      choices: choices.otherDocumentStates,
      modalContent: 'aboutOtherDoc',
      isVisible: state.documentState === 'none',
      isRequired: false,
      canSkip: true,
    }, {
      id: 'noDocument',
      name: 'noDocument',
      title: '診療情報の提供がありません',
      type: state.questionTypes.MESSAGE,
      messageKey: 'noDocument',
      choices: null,
      isVisible: state.documentState === 'none' && state.otherDocumentState === 'none',
      isRequired: false,
      canSkip: true,
    }, {
      id: 'submissionMethod',
      name: 'submissionMethod',
      title: <span>資料の提出方法を選択してください<br /><question-title-sm>※書類についてご不明な場合はスキップを押してください。ご登録完了後にオペレーターがサポート致します</question-title-sm></span>,
      type: state.questionTypes.RADIO,
      isVisible: state.documentState !== 'pending' &&
        (state.documentState === 'have' || state.otherDocumentState === 'have'),
      isRequired: false,
      choices: choices.submissionMethods,
      canSkip: true,
    }, {
      id: 'submissionMethod',
      name: 'submissionMethodNotPay',
      title: <span>資料の提出方法を選択してください<br /><question-title-sm>※書類についてご不明な場合はスキップを押してください。ご登録完了後にオペレーターがサポート致します</question-title-sm></span>,
      type: state.questionTypes.RADIO,
      isVisible: true,
      isRequired: false,
      isCounted: true,
      choices: choices.submissionMethodsNotPay,
      annotation: '主治医からは、診療情報提供書（紹介状）と、必要に応じて検査結果などの関連資料も合わせて提供されます。お手元にあるすべての情報をご提出いただきたく、CD-ROMの画像検査データなどご自身でデータ化してアップロードするのが難しい場合「郵送する」を選択し、次のステップにてご手配をお願いします。',
    }, {
      id: 'files',
      name: 'files',
      title: '紹介状および添付の検査データ等をアップロードしてください',
      type: state.questionTypes.UPLOADER,
      choices: null,
      isVisible: state.documentState !== 'pending' &&
        (state.documentState === 'have' || state.otherDocumentState === 'have')
        && state.submissionMethod === 'upload',
      isRequired: false,
      canSkip: true,
    }, {
      id: 'files',
      name: 'filesFWD001',
      title: '紹介状および添付の検査データ等をアップロードしてください',
      type: state.questionTypes.UPLOADER,
      choices: null,
      isVisible: state.documentState !== 'pending' &&
        (state.documentState === 'have' || state.otherDocumentState === 'have')
        && state.submissionMethod === 'upload',
      isRequired: true,
      isCounted: true,
    }, {
      id: 'returnAddress',
      name: 'returnAddress',
      title: 'お預りする紹介状等の返送先をご入力ください',
      type: state.questionTypes.ADDRESS,
      isVisible: state.documentState !== 'pending' &&
        (state.documentState === 'have' || state.otherDocumentState === 'have')
        && state.submissionMethod === 'post',
      isRequired: true,
      choices: null,
    }, {
      id: 'returnAddress',
      name: 'returnAddressFWD001',
      title: 'お預りする紹介状等の返送先をご入力ください',
      type: state.questionTypes.ADDRESS,
      isVisible: state.documentState !== 'pending' &&
        (state.documentState === 'have' || state.otherDocumentState === 'have')
        && state.submissionMethod === 'post',
      isRequired: true,
      isCounted: false,
      choices: null,
    }, {
      id: 'postAddress',
      name: 'postAddress',
      title: '資料の郵送について',
      type: state.questionTypes.MESSAGE,
      messageKey: 'postAddress',
      isVisible: state.documentState !== 'pending' &&
        (state.documentState === 'have' || state.otherDocumentState === 'have')
        && state.submissionMethod === 'post',
      isRequired: false,
      choices: null,
    }, {
      id: 'contentConsultation',
      name: 'contentConsultation',
      title: '最後に追加でご相談内容がある場合はご入力ください ※登録完了後も追加・修正可能です',
      type: state.questionTypes.TEXTAREA,
      choices: null,
      isVisible: true,
      isRequired: false,
      canSkip: true,
      placeholder: '医師に聞きたいことや不安に思っていることをご入力ください。 また、いままでの経緯や、現在の状況について医師に伝えたいことがあれば併せてご記載ください。',
      example: '現在の年齢は35歳ですが、治療が無事に終えられたら、妊娠を希望しています。主治医の先生から、術後の抗がん剤治療は必ずしなければならないと言われていますが、手術後の抗がん剤治療は必須なのか、抗がん剤治療を受けないという選択肢はありうるのか、教えてください。また、いま予定している抗がん剤治療を受けた場合の、将来の妊娠への影響についても詳しく教えてください。'
    }, {
      id: 'contentConsultation',
      name: 'contentConsultationFWD001',
      title: '最後に追加でご相談内容がある場合はご入力ください ※登録完了後も追加・修正可能です',
      type: state.questionTypes.TEXTAREA,
      choices: null,
      isVisible: true,
      isRequired: true,
      isCounted: true,
      placeholder: '医師に聞きたいことや不安に思っていることをご入力ください。ご質問の前提として、これまでの経緯や現在の治療方針についてもおわかりになる範囲で記載いただくと、ご質問のポイントがわかりやすくなります。【月経の状況】【将来の妊娠のご希望、出産のご経験】についても治療方法の選択において重要ですので、ご記載をお願いいたします。',
      example: '■これまでの経緯と現在の治療計画<br>20xx年m月 ABC病院にて子宮頸がんⅠB2期と診断<br>20xx年m月d日 子宮の全摘出を予定<br>術後に放射線治療と化学療法を行う予定（詳細は紹介状参照）<br><br>■相談内容<br>全摘出を避ける方法はないでしょうか？また、術後に抗がん剤治療を追加することも必要ですか？抗がん剤の副作用についてとても心配です。<br><br>■月経の状況：毎月、自分では異常ないと思っていた。<br>■妊娠について：出産経験なし。妊娠の希望は最優先ではありませんが、再発リスクを抑えながら、治療後に妊娠の可能性を残す治療法があるのか知りたい。'
    }, {
      id: 'thanks',
      name: 'thanks',
      title: '相談入力終了',
      type: state.questionTypes.TO_PAYMENT,
      message: <div>ご入力ありがとうございました<br/>続いてお支払い手続きに進んでください</div>,
      choices: null,
      isVisible: true,
      isRequired: false,
      isLastQuestion: true,
    }, {
      id: 'thanks',
      name: 'thanksNotPay',
      title: '相談入力が完了しました',
      type: state.questionTypes.TO_PAYMENT,
      message: <div>ご相談内容を確認し相談を投稿してください。上にスクロールすると、入力項目を確認・修正いただけます。</div>,
      buttonText: '相談を投稿',
      choices: null,
      isVisible: true,
      isRequired: false,
      isLastQuestion: true,
    }
  ]
  return questions
}

const questionsFilter = (names, questions) => {
  const filteredQuestions = names.map(
    name => questions.filter(q => q.name === name)[0]
  )
  return filteredQuestions
}

const makeQuestions = (state = initialState, choices = initialState.choices) => {
  let questions = questionList(state, choices)
  let requiredNames = []
  let optionalNames = []
  let thanksNames = []

  if (state.campaign === 'FWD') {
    requiredNames = [
      'patientType',
      'birthYear',
      'diseaseName',
      'consultationDetails',
      'cancerTypeFWD001',
      'cancerStep',
      'otherDiseaseNames',
      'hospitalName',
      'offerArea',
      'expirationDate',
      'expirationDateComment',
      'toNextStep',
    ]
    optionalNames = [
      'documentState',
      'attention',
      'otherDocumentState',
      'noDocument',
      'submissionMethodNotPay',
      'files',
      'postAddress',
      'returnAddressFWD001',
      'contentConsultation'
    ]
    thanksNames = ['thanksNotPay']

  } else if (state.campaign === 'AFLAC'){
      requiredNames = [
        'patientType',
        'diseaseName',
        'birthYear',
        'consultationDetails',
        'cancerType',
        'cancerStep',
        'otherDiseaseNames',
        'hospitalName',
        'offerArea',
        'expirationDate',
        'expirationDateComment',
        'toNextStep',
      ]
      optionalNames = [
        'documentState',
        'attention',
        'otherDocumentState',
        'noDocument',
        'submissionMethodNotPay',
        'files',
        'postAddress',
        'returnAddress',
        'contentConsultation'
      ]
      thanksNames = ['thanksNotPay']
  } else {
    requiredNames = [
      'patientType',
      'diseaseName',
      'birthYear',
      'consultationDetails',
      'cancerType',
      'cancerStep',
      'otherDiseaseNames',
      'hospitalName',
      'offerArea',
      'expirationDate',
      'expirationDateComment',
      'toPayment',
    ]
    optionalNames = [
      'documentState',
      'attention',
      'otherDocumentState',
      'noDocument',
      'submissionMethod',
      'files',
      'postAddress',
      'returnAddress',
      'contentConsultation'
    ]
    thanksNames = ['thanks']
  }
  let requiredQuestions = questionsFilter(requiredNames, questions)
  let optionalQuestions = questionsFilter(optionalNames, questions)
  let thanks = questionsFilter(thanksNames, questions)
  if(state.isSentRequest) {
    questions = optionalQuestions
  } else {
    questions = requiredQuestions.concat(optionalQuestions, thanks)
  }
  return questions
}

// update customer info
export const updateRequestInfo = (isSavedByCustomer = true) => {
  return (dispatch, getState) => {
    let state = getState()
    let signup = state.signup

    if (!signup.requestId) return

    let data = makeRequestPostData(signup)

    // save by customer
    if (isSavedByCustomer) {
      // don't allow to save manually without payjp token if
      // payment is required.
      let requiresPayment = signup.annotationPrice.requires_payment
      if (requiresPayment && !signup.payjpToken) {
        return
      }

      // only pass these params when save by customer
      data.request_info.payjp_token = signup.payjpToken
      data.request_info.is_saved_by_customer = true
      dispatch(updateRequestInfoRequest({
        id: signup.requestId,
        data: data,
        successCallback: () => {
          dispatch(updateSignUpData({
            step: 6,
            isSavedByCustomer: true,
            isSentRequest: true,
            autoSaveNotification: '',
            currentlyUpdating: false,
            conversion_value: signup.annotationPrice.conversion_value
          }))
        }
      }))
    // autosave
    } else {
      let now = new Date()
      dispatch(updateRequestInfoRequest({
        id: signup.requestId,
        data: data,
        delay: 1000,
        successCallback: () => {
          dispatch(updateSignUpData({
            isSavedByCustomer: false,
            autoSaveNotification: '自動保存 ' + dateformat(now, 'yyyy-mm-dd HH:MM'),
            currentlyUpdating: false,
          }))
        },
      }))
    }
  }
}

// hospital suggestions
let searchHospitalTimeout

export const changeHospitalKeyword = (keyword) => {
  return (dispatch, getState) => {
    // cancel previous search
    clearTimeout(searchHospitalTimeout)

    dispatch(updateSignUpSettings({
      hospitalName: keyword,
    }))

    if (!keyword.trim()) {
      dispatch(updateSignUpSettings({
        hospitalId: '',
        hospitals: []
      }))
      return
    }

    searchHospitalTimeout = setTimeout(() => {
      dispatch(searchHospitalRequest(keyword))
    }, 600)
  }
}

// upload files
export const uploadFiles = (files) => {
  return (dispatch, getState) => {
    let state = getState()

    let maxFileSize = 50 // Megabyte

    // prevent upload files have size larger than maxFileSize
    for (let i in files) {
      let file = files[i]
      if ((file.size / 1e6) > maxFileSize) {
        dispatch(updateSignUpSettings({
          errors: {
            file: `${maxFileSize} MBのファイルまでアップロード可能です`
          }
        }))
        return
      }
    }

    // check valid file extensions
    for (let i = 0; i < files.length; i++) {
      let file = files[i]
      let fileName = file.name
      if (!isAllowedFileExtension(fileName)) {
        let errorMessage = `対応していない形式のファイルです`
        dispatch(updateSignUpSettings({
          errors: {
            file: errorMessage
          }
        }))
        // exit immediately
        return
      }
    }

    // @see https://github.com/axios/axios/issues/318#issuecomment-218948420
    // @see https://stackoverflow.com/a/15822105/2833319
    for (let i = 0; files[i]; i++) {
      let file = files[i]
      let form = new FormData()
      form.append(`file[filename]`, file.name)
      form.append(`file[content_type]`, file.type)
      form.append(`file[size]`, file.size)
      form.append('target_id', state.signup.requestId)
      form.append('target', 'request')

      dispatch(uploadFileRequest({
        data: form,
        successCallback: (response) => {
          // Append this file now.
          response.file.uploading = true
          dispatch(updateFilesResponse({
            files: [response.file]
          }))
          let form = new FormData()
          for (let key in response.file.upload_fields) {
            let value = response.file.upload_fields[key]
            form.append(key, value)
          }
          form.append('file', file)

          dispatch(uploadFileToS3({
            url: response.file.upload_url,
            fields: form,
            onUploadProgress: (percent) => {
              response.file.progress = percent
              response.file.uploading = true
              dispatch(updateFilesResponse({
                files: [response.file]
              }))
            },
            successCallback: () => {
              response.file.progress = 100
              response.file.uploading = false
              dispatch(uploadFilesSuccess({
                files: [response.file]
              }))
            }
          }))
        }
      }))
    }
  }
}

export const updateFilesResponse = (response) => {
  return (dispatch, getState) => {
    let state = getState()
    let files = state.signup.files.slice()
    for (var i = 0; i < response.files.length; i++) {
      let newFile = response.files[i]
      let fileToUpdateIdx = files.findIndex(e => e.id === newFile.id)
      if (fileToUpdateIdx >= 0) {
        files[fileToUpdateIdx] = newFile
      } else {
        files.push(newFile)
      }
    }

    dispatch(updateSignUpSettings({
      files: files,
      errors: {}
    }))
  }
}

export const uploadFilesSuccess = (response) => {
  return (dispatch, getState) => {
    let state = getState()
    dispatch(updateFileTargetIdRequest(response.files[0].id, state.signup.requestId))
    dispatch(updateFilesResponse(response))
  }
}

// delete files
export const deleteFile = (fileId) => {
  return (dispatch, getState) => {
    dispatch(deleteFileRequest({
      fileId: fileId,
      successCallback: (response) => {
        if (response.status !== 'success') {
          return
        }
        let state = getState()
        let files = state.signup.files
        files = files.filter(file => file.id !== fileId)
        dispatch(updateSignUpSettings({
          files: files
        }))
      }
    }))
  }
}

export const deleteDirectoryUpload = (requestId, directoryUploadId) => {
  return (dispatch, getState) => {
    dispatch(deleteDirectoryUploadRequest({
      requestId,
      directoryUploadId,
      successCallback: (response) => {
        if (response.status !== 'success') {
          return
        }
        let state = getState()
        let dirUploads = Object.assign({}, state.signup.directoryUploads)
        delete dirUploads[directoryUploadId]
        dispatch(updateSignUpSettings({
          directoryUploads: dirUploads
        }))
      }
    }))
  }
}

const _uploadAllDirectoryFiles = async (dispatch, requestId, dir_up, files, totalFileSize) => {
  dispatch(updateDirectoryUploadProgress({
    directoryUploadId: dir_up.directory_upload.id,
    progressPercent: 0,
    fileCount: files.length,
    totalFileSize
  }))

  // it's important the files is an array here, and that we own it,
  // because we're going to be popping things off it.
  const ourFiles = files.slice()

  let uploadedBytes = 0
  const inflightUploads = {}

  const notifyUploadProgress = (finalized = false) => {
    const inflightBytes = Object.keys(inflightUploads).map((k) => inflightUploads[k]).reduce((m, s) => m + s, 0)
    const allBytes = uploadedBytes + inflightBytes
    const percentCompleted = Math.floor((allBytes * 100) / totalFileSize)

    dispatch(updateDirectoryUploadProgress({
      directoryUploadId: dir_up.directory_upload.id,
      progressPercent: percentCompleted,
      finalized
    }))
  }

  const updateUploadProgress = (id, currentBytes) => {
    inflightUploads[id] = currentBytes
    notifyUploadProgress()
  }

  const finalizeUpload = (id, totalBytes) => {
    delete inflightUploads[id]
    uploadedBytes += totalBytes
    notifyUploadProgress()
  }

  const promiseProducer = () => {
    let file = ourFiles.pop()
    if (typeof file === 'undefined') {
      return null
    }

    return (async () => {
      const tempId = Math.random().toString(36).replace(/[^a-z]+/g, '')

      let form = new FormData()
      for (let key in dir_up.presigned.upload_fields) {
        let value = dir_up.presigned.upload_fields[key]
        form.append(key, value)
      }
      let s3key = dir_up.directory_upload.key_prefix + file.webkitRelativePath
      s3key = s3key.replace('//', '/')
      form.append('key', s3key)
      form.append('file', file)

      await axios.post(dir_up.presigned.url, form, {
        onUploadProgress: progressEvent => {
          // progressEvent.loaded is the size of the whole request, not just the upload file....
          updateUploadProgress(tempId, progressEvent.loaded)
        }
      })

      // But, it's reconciled here because we finalize the upload
      // with the file size, not the request size.
      finalizeUpload(tempId, file.size)
    })()
  }

  const concurrency = 3

  const pool = new PromisePool(promiseProducer, concurrency)

  try {
    await pool.start()

    await api.uploadDirectoryFinished(requestId, dir_up.directory_upload.id)

    dispatch(updateDirectoryUploadProgress({
      directoryUploadId: dir_up.directory_upload.id,
      progressPercent: 100,
      finalized: true
    }))
  } catch (error) {
    console.error("Problem.")
    console.error(error)
  }
}

// upload directory
export const uploadDirectory = (files) => {
  return (dispatch, getState) => {
    let state = getState()

    let maxDirectorySize = 10 * (2**30) // 10 gibibytes
    let fileCount = files.length

    if (fileCount === 0) {
      alert("ご指定のフォルダーにファイルが見つかりませんでした。もう一度ご確認の上、試してください。")
      return
    }

    let fileArray = Array.from(files)
    let totalFileSize = fileArray.map((f) => f.size).reduce((m, s) => m + s)

    // prevent directory uploads over than 10 GB
    if (totalFileSize > maxDirectorySize) {
      alert("10 GB 以上のアップロードは現在受付できません。郵送オプションをご検討ください。")
      return
    }

    dispatch(uploadDirectoryRequest({
      requestId: state.signup.requestId,
      fileCount,
      totalFileSize,
      successCallback: (response) => {
        _uploadAllDirectoryFiles(
          dispatch,
          state.signup.requestId,
          response,
          fileArray,
          totalFileSize
        )
      }
    }))
  }
}

export const updateDirectoryFile = (response) => {
  return (dispatch, getState) => {
    let state = getState()
    let files = state.signup.files.slice()
    for (var i = 0; i < response.files.length; i++) {
      let newFile = response.files[i]
      let fileToUpdateIdx = files.findIndex(e => e.id === newFile.id)
      if (fileToUpdateIdx >= 0) {
        files[fileToUpdateIdx] = newFile
      } else {
        files.push(newFile)
      }
    }

    dispatch(updateSignUpSettings({
      files: files,
      errors: {}
    }))
  }
}

// update request status
export const updateRequestStatus = (status) => {
  return (dispatch, getState) => {
    let state = getState()
    let signup = state.signup

    let data = {
      request_info: {
        status: status
      }
    }

    dispatch(updateRequestInfoRequest({
      id: signup.requestId,
      data: data,
      successCallback: () => {
        dispatch(updateSignUpSettings({
          status: status
        }))
      }
    }))
  }
}

// fetch data files
export const fetchSidebarDataRequest = () => ({
  type: FETCH_DATA_FILE_REQUEST
})

export const toggleAnnotationImageModal = (src) => ({
  type: TOGGLE_ANNOTATION_IMAGE_MODAL,
  src
})

export const updateSignUpSettings = (payload, updateNow = false, isSavedByCustomer = false) => {
  return dispatch => {
    dispatch(updateSignUpData(payload))
    if (auth.loggedIn() && updateNow) {
      dispatch(updateRequestInfo(isSavedByCustomer))
    }
  }
}

export const changeSignUpStep = (step, updateNow = false) => {
  return (dispatch, getState) => {
    let signup = getState().signup
    let isSavedByCustomer = false
    // 対象キャンペーンなら決済スキップ
    if(step === 5 && (signup.campaign === 'FWD' || signup.campaign === 'AFLAC')) {
      isSavedByCustomer = true
      step = 6
    }

    dispatch(updateSignUpData({step}))

    if (auth.loggedIn() && updateNow) {
      dispatch(updateRequestInfo(isSavedByCustomer))
    }
  }
}

export const updateFileTargetIdRequest = (file_id, target_id) => {
  return {
      type: UPDATE_FILE_TARGET_ID_REQUEST,
      fileId: file_id,
      targetId: target_id
  }
}



// WEBPACK FOOTER //
// ./src/routes/signup/modules/signup.js